import React from 'react';
import Slider from '../components/Slider';
import HomeCategory from '../components/HomeCategory';
import About from '../components/About';
import { DATA } from '../data/urunler-data';
import { Link } from 'react-router-dom';
import SomeProducts from '../components/SomeProducts';
import BrandSlider from '../components/BrandSlider';
import HomeCategoryIndex from '../components/HomeCategoryIndex';




const Anasayfa = () => {


  return (
    <div className='w-full flex flex-col shadow-sm '>
      <Slider />
   


      <HomeCategoryIndex/>

      <About />
      {/* <SomeProducts/> */}
      {/* <BrandSlider/> */}






    </div>
  );
};

export default Anasayfa;
